import React from 'react';
import { HindiCCA2023 } from 'views/Literaryclub2023/components';

const LifeSkillPage = () => {
  return <HindiCCA2023/>;
};

export default LifeSkillPage;